import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CloneTemplateButton from 'components/template/CloneTemplateButton';

import { useEvent } from 'components/context/EventContext';

import { IconmoonFont } from 'vibo-ui/Icon';

import Button from 'vibo-ui/Button';

const AddToTemplatesButton: FC = () => {
  const { t } = useTranslation();

  const { event, isEditable } = useEvent();
  const template = (event as unknown) as Template;

  return template.isPublic && !isEditable ? (
    <CloneTemplateButton
      template={template}
      renderButton={onClick => (
        <Button
          onClick={e => onClick(e)}
          prefixIcon={IconmoonFont['plus-24']}
          displayType="bordered"
          shape="round"
          size="lg"
        >
          {t('addToMyTemplates')}
        </Button>
      )}
    />
  ) : null;
};

export default AddToTemplatesButton;
